import React from 'react';
import { Link } from 'react-router-dom';
import cImg from '../../images/prices/image-1.jpg';

const Newsletter = props => {
	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<section className='relative pt-[100px] pb-[95px] z-10'>
			<div className='wraper'>
				<div className='grid grid-cols-12 gap-3'>
					<div className='col-span-12 md:col-span-12 col:col-span-12'>
						<div className='col:w-full mx-auto'>
							<h3 className='text-[36px] sm:text-[22px] font-medium mb-[20px] sm:mb-[30px] text-[#282e3f]'>
								1. Préambule
							</h3>
							<p className='text-[#666] pb-4'>
								Le cabinet GAVA-<i>Lex</i> (dont les bureaux sont sis à 6000 CHARLEROI, Bld. Dewandre,
								6, inscrit à la B.C.E. sous le numéro 0787.651.282) accorde une grande importance à la
								protection adéquate des données qu'il traite.{' '}
							</p>
							<p className='text-[#666] pb-4'>
								En effet, dans le cadre de son fonctionnement, le cabinet et ses avocats collectent et
								traitent certaines données en qualité de responsable du traitement au sens de la loi
								belge du 8 décembre 1992 relative à la protection de la vie privée et au sens du
								Règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016 relatif à
								la protection des personnes physiques à l'égard du traitement des données à caractère
								personnel et à la libre circulation de ces données.{' '}
							</p>
							<p className='text-[#666] pb-4'>
								Actuellement, les avocats travaillant au sein de ce cabinet sont :
								<ul className='list-disc ml-8'>
									<li>Maître Jean-François GAILLY</li>
									<li>Maître Dimitri VAN WYMEERSCH</li>
									<li>Maître Maïté ABAD ET ORTEGA</li>
									<li>Maître Hugue RADELET</li>
								</ul>
							</p>
							<p className='text-[#666] pb-4'>
								Le cabinet protège ces données à caractère personnel contre tout risque de perte, de
								fuites, d'erreurs, d'inaccessibilité, de consultation illicite et contre tout traitement
								non conforme à la réglementation, aux directives et aux normes.
							</p>
							<p className='text-[#666] pb-4'>
								En cas de difficulté quant à l'utilisation de vos données, il est possible de nous
								contacter en écrivant au siège social du cabinet (Bd Frans Dewandre 6 à 6000 Charleroi),
								ou par téléphone au 071/70.02.02.
							</p>

							<h3 className='text-[36px] sm:text-[22px] font-medium mt-[40px] mb-[20px] sm:mb-[30px] text-[#282e3f]'>
								2. Données traitées par le cabinet
							</h3>
							<h4 className='text-[28px] sm:text-[16px] font-medium mt-[40px] mb-[20px] sm:mb-[30px] text-[#282e3f]'>
								2.1 Données des clients et des parties intervenantes dans un dossier
							</h4>
							<p className='text-[#666] pb-4'>
								Après l'ouverture d'un dossier auprès de notre cabinet, des données personnelles, tant
								du client, de l'adversaire que des parties intervenantes au dossier (famille, confrères,
								assurances, banques, huissiers, notaires, conseils techniques, experts, …) seront
								recueillies en vue de l'exécution des prestations sollicitées par le client, dans le
								cadre d'un contrat, dans l'intérêt légitime d'une procédure en justice et dans le cadre
								de nos obligations légales prévues aux articles 508/1 et suivants et 728 du Code
								judiciaire.
							</p>
							<p className='text-[#666] pb-4'>
								Dans le cadre des dossiers, des données peuvent également être reçues de ces différents
								intervenants.
							</p>
							<p className='text-[#666] pb-4'>
								Ces données peuvent être de plusieurs catégories :
								<ul className='list-disc ml-8'>
									<li>
										Données relatives à l'identification de la personne (l'état civil, le nom, le
										prénom, l'année de naissance, la profession, le numéro de registre national)
									</li>
									<li>Données relatives à la composition du ménage ;</li>
									<li>
										Données de contact (le numéro de téléphone, le numéro de fax, l'adresse mail, le
										lieu de résidence ou le domicile) ;
									</li>
									<li>
										Données financières, bancaires et fiscales (comptes bancaires, solvabilité,
										allocations, conventions, revenus, dettes, assurances)
									</li>
									<li>
										Données relatives au dossier, pouvant être des données de catégories
										particulières en fonction du type de dossier (données médicales, sexuelles,
										judiciaires, relatives aux condamnations pénales et aux infractions ou aux
										enfants, aux opinions politiques et syndicales, aux convictions philosophiques
										ou religieuses)
									</li>
								</ul>
							</p>
							<p className='text-[#666] pb-4'>
								Les données récoltées dépendront du type de prestation sollicitée du cabinet. Ces
								données personnelles seront stockées tant dans des fichiers informatiques que dans des
								dossiers papiers, au sein des locaux du cabinet.
							</p>
							<p className='text-[#666] pb-4'>
								Dans le cadre de sa gestion des dossiers, le cabinet fait usage du logiciel de gestion
								KLEOS, appartenant à la société WOLTERS KLUWER. Cette société procure une sauvegarde des
								données reprises dans ce logiciel dans un centre conforme aux règles en vigueur, situé
								en Italie.
							</p>
							<p className='text-[#666] pb-4'>
								Ces données seront traitées de manière confidentielle conformément aux dispositions
								légales par le personnel, la collaboratrice et le comptable externe, ces personnes
								n'ayant accès qu'aux données nécessaires à l'exercice de leur fonction. Lors de la
								réutilisation du travail déjà presté dans le cadre d'un dossier pour un autre dossier,
								un avocat pourrait également avoir accès à certaines données.
							</p>
							<p className='text-[#666] pb-4'>
								Ces données ainsi collectées sont uniquement traitées dans les finalités suivantes :
								<ul className='list-disc ml-8'>
									<li>Pour les contacts dans le cadre du dossier et la gestion de la clientèle</li>
									<li>Pour la vérification d'éventuels conflits d'intérêts</li>
									<li>Pour la gestion du dossier</li>
									<li>
										Pour votre défense, la gestion de votre contentieux et pour l'exécution du
										mandat ad litem
									</li>
									<li>Pour la fourniture de services juridiques</li>
									<li>Pour la gestion des comptes et la facturation</li>
									<li>
										Pour le recouvrement des créances dues au cabinet et l'éventuel contentieux
										pouvant découler de nos prestations
									</li>
									<li>Pour la gestion des demandes relatives aux droits des personnes concernées</li>
									<li>Pour le respect de nos obligations légales</li>
								</ul>
							</p>
							<p className='text-[#666] pb-4'>
								Sauf avec votre accord écrit et expresse ou dans le cadre des obligations qui nous
								incombent en vertu de la loi du 18 septembre 2017 relative à la prévention du
								blanchiment de capitaux et du financement du terrorisme et à la limitation de
								l'utilisation des espèces, ces données ne seront jamais transmises à un tiers, à
								l'exception :
								<ul className='list-disc ml-8'>
									<li>
										des avocats, des huissiers, des médiateurs, des arbitres, des conseils
										techniques, des notaires, des assureurs, des banques, des comptables, des
										experts, des tribunaux, ou toute autre instance ou tout autre intervenant
										participant au dossier, pour la gestion du dossier et pour la fourniture de
										services juridiques ;
									</li>
									<li>
										du cabinet d'avocat et de l'huissier chargés du recouvrement des honoraires du
										cabinet ou en cas de litige ;
									</li>
									<li>
										des administrations fédérales, tant fiscales que sociales, pour le respect de
										nos obligations légales ;
									</li>
									<li>du comptable pour la facturation et le respect de nos obligations légales ;</li>
									<li>
										du Bureau d'aide juridique, dans le cadre des dossiers d'aide juridique, pour le
										respect de nos obligations légales ;
									</li>
									<li>
										des instances ordinales, dans le cadre de nos obligations légales et
										déontologiques.
									</li>
								</ul>
							</p>
							<p className='text-[#666] pb-4'>
								Ces données seront conservées 10 ans après la clôture de notre intervention, afin de
								respecter les obligations qui nous incombent dans le cadre de la loi du 18 septembre
								2017, sauf dans l'hypothèse d'une procédure en recouvrement de nos honoraires ou d'un
								litige. Dans cette hypothèse, vos données seront conservées 10 ans après la clôture du
								dossier de recouvrement ou du litige.
							</p>

							<h4 className='text-[28px] sm:text-[16px] font-medium mt-[40px] mb-[20px] sm:mb-[30px] text-[#282e3f]'>
								2.2 Données du personnel et des candidats
							</h4>
							<p className='text-[#666] pb-4'>
								Dans le cadre de la gestion de son recrutement, de son personnel, de ses salaires et de
								sa comptabilité, le cabinet traite des données à caractère personnel des membres de son
								personnel, dans le cadre de la relation contractuelle liant les parties.
							</p>
							<p className='text-[#666] pb-4'>
								Ces données sont de plusieurs catégories :
								<ul className='list-disc ml-8'>
									<li>
										Données relatives à l'identification de la personne (l'état civil, le nom, le
										prénom, l'année de naissance, la profession, le numéro de registre national){' '}
									</li>
									<li>Données relatives à la composition du ménage ;</li>
									<li>
										Données de contact (le numéro de téléphone, le numéro de fax, l'adresse mail, le
										lieu de résidence ou le domicile) ;
									</li>
									<li>
										Données relatives aux qualifications professionnelles (parcours professionnel,
										compétences, langues, domaines de spécialisation, diplômes et titres académiques
										ou professionnels)
									</li>
									<li>Données financières, bancaires et fiscales</li>
									<li>
										Le cas échéant, des données de catégories particulières, tels que les données
										médicales
									</li>
								</ul>
							</p>
							<p className='text-[#666] pb-4'>
								Ces données sont stockées tant dans des fichiers informatiques que dans des dossiers
								papiers, au sein des locaux du cabinet.
							</p>
							<p className='text-[#666] pb-4'>
								Celles-ci sont traitées de manière confidentielle par les avocats et certaines d'entre
								elles sont transmises au secrétariat social, à l'assureur « accident du travail », et au
								comptable, dans le cadre de leurs prestations. Ces destinataires n'auront accès qu'aux
								données nécessaires à l'exercice de leur fonction.
							</p>
							<p className='text-[#666] pb-4'>
								Ces données seront conservées pendant 7 ans après la clôture des relations
								professionnelles, sauf dans l'hypothèse d'un contentieux. Dans cette dernière hypothèse,
								vos données seront conservées 10 ans après la clôture du litige.
							</p>
							<p className='text-[#666] pb-4'>
								Lors de la réception d'une candidature, les données reçues seront traitées dans la
								mesure nécessaire à la gestion de ladite candidature. Si une candidature n'était pas
								retenue, celle-ci et les données y relatives seront supprimées dans un délai de 2 mois
								après le terme du processus de recrutement ou 2 mois après la réception en cas de
								candidature spontanée.
							</p>

							<h4 className='text-[28px] sm:text-[16px] font-medium mt-[40px] mb-[20px] sm:mb-[30px] text-[#282e3f]'>
								2.3 Données des collaborateurs, des fournisseurs, des éditeurs, des coauteurs et de tout
								autre sous-traitant
							</h4>
							<p className='text-[#666] pb-4'>
								Dans le cadre de l'exécution des conventions avec les collaborateurs, les fournisseurs,
								les éditeurs, les coauteurs ou avec tout autre sous-traitant, le cabinet récolte et
								traite des données en vue de l'exécution de la convention.
							</p>
							<p className='text-[#666] pb-4'>
								Ces données sont de différentes catégories :
								<ul className='list-disc ml-8'>
									<li>
										Données relatives à l'identification de la personne (l'état civil, le nom, le
										prénom, l'année de naissance, la profession, le numéro de registre national,
										numéro de TVA)
									</li>
									<li>
										Données de contact (le numéro de téléphone, le numéro de fax, l'adresse mail, le
										lieu de résidence ou le domicile) ;
									</li>
									<li>Données bancaires et financières ;</li>
									<li>Données relatives aux activités professionnelles et aux services prestés ;</li>
								</ul>
							</p>
							<p className='text-[#666] pb-4'>
								Ces données personnelles seront stockées tant dans des fichiers informatiques que dans
								des dossiers papiers, au sein des locaux du cabinet.{' '}
							</p>
							<p className='text-[#666] pb-4'>
								Ces données seront traitées de manière confidentielle conformément aux dispositions
								légales par le personnel, le comptable externe et les associés, ces personnes n'ayant
								accès qu'aux données nécessaires à l'exercice de leur fonction.
							</p>
							<p className='text-[#666] pb-4'>
								Ces données ainsi collectées sont uniquement traitées dans les finalités suivantes :
								<ul className='list-disc ml-8'>
									<li>Pour l'administration des relations contractuelles</li>
									<li>Pour l'administration des paiements</li>
									<li>Pour la prospection des sous-traitants</li>
								</ul>
							</p>
							<p className='text-[#666] pb-4'>
								Ces données ne seront jamais transmises à un tiers, à l'exception :
								<ul className='list-disc ml-8'>
									<li>
										des administrations fédérales, tant fiscales que sociales, pour le respect de
										nos obligations légales ;
									</li>
									<li>du comptable pour la facturation et le respect de nos obligations légales ;</li>
									<li>du client du cabinet, si ce sous-traitant intervient dans son dossier ;</li>
								</ul>
							</p>
							<p className='text-[#666] pb-4'>
								Ces données seront conservées 10 ans à compter de la rupture des relations, sauf dans
								l'hypothèse d'un litige. Dans cette dernière hypothèse, vos données seront conservées 10
								ans après la clôture du litige.
							</p>

							<h4 className='text-[28px] sm:text-[16px] font-medium mt-[40px] mb-[20px] sm:mb-[30px] text-[#282e3f]'>
								2.4 Données des membres des instances ordinales
							</h4>
							<p className='text-[#666] pb-4'>
								Afin de pouvoir exercer notre profession et respecter notre déontologie, le cabinet
								traitera des données des membres des instances ordinales :
								<ul className='list-disc ml-8'>
									<li>
										Des données relatives à l'identification de la personne (l'état civil, le nom,
										le prénom, l'année de naissance, la profession, le numéro de registre national,
										numéro de TVA)
									</li>
									<li>
										Des données de contact (le numéro de téléphone, le numéro de fax, l'adresse
										mail, le lieu de résidence ou le domicile) ;
									</li>
								</ul>
							</p>
							<p className='text-[#666] pb-4'>
								Ces données sont traitées pour les finalités suivantes :
								<ul className='list-disc ml-8'>
									<li>Pour la communication avec Avocats.be et le barreau</li>
									<li>Pour le respect des obligations déontologiques</li>
								</ul>
							</p>
							<p className='text-[#666] pb-4'>Ces données ne seront jamais transmises à un tiers.</p>
							<p className='text-[#666] pb-4'>
								Ces données seront conservées 5 ans à compter de l'arrêt des activités.
							</p>

							<h4 className='text-[28px] sm:text-[16px] font-medium mt-[40px] mb-[20px] sm:mb-[30px] text-[#282e3f]'>
								2.5 Données traitées dans le cadre de la gestion informatique et de la destruction des
								dossiers
							</h4>
							<p className='text-[#666] pb-4'>
								Lors de la maintenance ou d'une réparation du matériel informatique, il est possible que
								des données puissent être consultées ou copiées de manière éphémère.
							</p>
							<p className='text-[#666] pb-4'>
								Cette consultation ou cette copie sont nécessaires au fonctionnement du cabinet et à la
								préservation des données. Si une copie devait être réalisée, celle-ci sera supprimée
								immédiatement après la maintenance ou la réparation par la société mandatée.
							</p>
							<p className='text-[#666] pb-4'>
								Lors de la destruction des dossiers, il est possible que des données puissent être
								consultées de manière éphémère.
							</p>
							<h4 className='text-[28px] sm:text-[16px] font-medium mt-[40px] mb-[20px] sm:mb-[30px] text-[#282e3f]'>
								2.6 Données recueillies par les cameras
							</h4>
							<p className='text-[#666] pb-4'>
								Le cabinet étant muni de caméras de surveillance, les visiteurs du cabinet et les
								employés seront filmés et des données relatives à leur localisation et leur image seront
								récoltées. Les visiteurs sont avertis de la présence de ces caméras par les pictogrammes
								présents au sein des locaux. Ces caméras sont installées uniquement dans un but de
								sécurisation des locaux. Les images récoltées sont accessibles uniquement par les
								associés du cabinet. Celles-ci ne seront jamais transmises à un tiers sauf dans
								l'hypothèse d'une enquête policière ou d'un contentieux.
							</p>
							<p className='text-[#666] pb-4'>
								Ces données sont stockées sur un serveur indépendant présent dans le cabinet et les
								données sont effacées tous les mois.
							</p>
							<h4 className='text-[28px] sm:text-[16px] font-medium mt-[40px] mb-[20px] sm:mb-[30px] text-[#282e3f]'>
								2.7 Données des visiteurs du site internet
							</h4>
							<p className='text-[#666] pb-4'>
								Le cabinet GAVA-<i>Lex</i> est propriétaire du site internet http://www.gava-lex.be/ qui
								est hébergé chez Infomaniak (Suisse). Maître Dimitri VAN WYMEERSCH est également
								propriétaire du site internet http://www.avocat-van-wymeersch.be/ qui est hébergé chez
								Infomaniak (Suisse). La consultation de ces sites n'entraîne aucune collecte automatique
								de données, sous réserve des informations transmises volontairement en adressant des
								courriers électroniques aux adresses reprises sur le site internet.
							</p>
							<p className='text-[#666] pb-4'>
								Les hébergeurs des emails sont la société PROXIMUS pour l'adresse @skynet.be, Avocats.be
								pour les adresses @avocat.be et Microsoft (Hosting en Europe) pour les adresses
								@gava-lex.be et @avocat-van-wymeersch.be.{' '}
							</p>
							<p className='text-[#666] pb-4'>
								Nous rappelons que le secret des correspondances transmises par le réseau Internet n'est
								pas garanti. Les courriers électroniques sont conservés sur support informatique, le
								temps nécessaire pour que le cabinet puisse les traiter et seront supprimés (sauf si ces
								courriers électroniques se rapportent à un autre traitement en cours de réalisation)
								après un délai maximum d'un mois.
							</p>
							<p className='text-[#666] pb-4'>
								Les hébergeurs stockent ces informations le temps nécessaire à leur traitement.
							</p>
							<p className='text-[#666] pb-4'>
								Certaines informations peuvent également être enregistrées par le biais des cookies. Ces
								cookies permettent une utilisation plus agréable et nous permettent de protéger notre
								site et d'avoir des statistiques de visite. Les informations obtenues par ce biais sont
								anonymes et ne nous permettent pas d'identifier le visiteur. Ces fichiers sont
								supprimables à tout moment et le blocage de ceux-ci peut être réalisé par
								l'intermédiaire de votre navigateur.
							</p>

							<h3 className='text-[36px] sm:text-[22px] font-medium mb-[20px] sm:mb-[30px] text-[#282e3f]'>
								3. Droits des personnes concernées
							</h3>
							<p className='text-[#666] pb-4'>
								Le Règlement général sur la protection des données accorde, à partir du 25 mai 2018,
								plusieurs droits aux personnes concernées, dont :
								<ul className='list-disc ml-8'>
									<li>Le droit d'accès aux données et d'obtenir une copie de celles-ci </li>
									<li>Le droit à la rectification des données </li>
									<li>Le droit d'effacement de ces données ou « droit à l'oubli » </li>
									<li>Le droit à la limitation du traitement </li>
									<li>Le droit à la portabilité des données </li>
									<li>Le droit d'opposition au traitement de vos données pour motifs légitimes</li>
								</ul>
							</p>
							<p className='text-[#666] pb-4'>
								Le client du cabinet, les membres du personnel, les candidats, les sous-traitants (y
								compris, leurs employés), les fournisseurs (y compris, leurs employés) et les membres
								des instances ordinales, qui justifieraient de leur identité, disposent de ces droits
								sur les données les concernant, à l'exception du droit d'effacement. Compte tenu de nos
								obligations légales et/ou de la nécessité de ces données dans le cadre de procédure en
								justice, le droit d'effacement ou « droit à l'oubli » ne pourra pas être accordé. En
								tout état de cause, toute demande excessive ou infondée pourra être refusée.
							</p>
							<p className='text-[#666] pb-4'>
								Toute demande doit être adressée par écrit ou en se présentant en personne au cabinet.
							</p>
							<p className='text-[#666] pb-4'>
								Le droit à la copie permet d'obtenir une copie gratuite sous format électronique de ses
								données à caractère personnel. Des frais administratifs pourraient être exigés pour
								toute copie sur format papier.{' '}
							</p>
							<p className='text-[#666] pb-4'>
								Si les personnes concernées n'obtiennent pas de réponse dans un délai de 30 jours, la
								demande doit être considérée comme ayant été rejetée.{' '}
							</p>
							<p className='text-[#666] pb-4'>
								Pour les autres personnes concernées, compte tenu de notre obligation au secret
								professionnel, des obligations légales, de la nécessité des données dans le cadre de
								procédure en justice et des atteintes aux droits et libertés de nos clients, aucun droit
								ne sera accordé. Si les personnes en question souhaitent faire valoir l'un de ces
								droits, celles-ci doivent s'adresser préalablement à l'Autorité de Protection des
								données (anciennement la Commission de la Protection de la Vie Privée).
							</p>
							<p className='text-[#666] pb-4'>
								Tout différend relatif à l'exercice de ces droits est tranché par le Tribunal de
								Première Instance.
							</p>

							<h3 className='text-[36px] sm:text-[22px] font-medium mb-[20px] sm:mb-[30px] text-[#282e3f]'>
								4. Plainte
							</h3>
							<p className='text-[#666] pb-4'>
								En cas de difficulté ou d'interrogation dans le cadre des traitements réalisés par le
								cabinet, le délégué à la protection des données peut vous apporter les renseignements
								nécessaires. L'Autorité de protection des données, dont les bureaux sont sis à 1000
								Bruxelles, Rue de la Presse, 35, téléphone 02/274.48.00, email :
								commission@privacycommission.be, est, quant à elle, compétente pour recevoir vos
								plaintes.
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Newsletter;
